import { render, staticRenderFns } from "./QuestionAnswers.vue?vue&type=template&id=6984a868&"
import script from "./QuestionAnswers.vue?vue&type=script&lang=js&"
export * from "./QuestionAnswers.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAnswers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports